<script setup lang="ts"></script>

<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.29289 8.79304C4.90237 9.18357 4.90237 9.81673 5.29289 10.2073L10.5858 15.5002C11.3668 16.2812 12.6332 16.2812 13.4142 15.5002L18.7071 10.2073C19.0976 9.81673 19.0976 9.18357 18.7071 8.79304C18.3166 8.40252 17.6834 8.40252 17.2929 8.79304L12 14.0859L6.70711 8.79304C6.31658 8.40252 5.68342 8.40252 5.29289 8.79304Z"
      fill="currentColor"
    />
  </svg>
</template>
